// extracted by mini-css-extract-plugin
module.exports = {"bg":"about-the-team_bg__FETBF","leftCopy":"about-the-team_leftCopy__kopCR"};